<template>

  <div id="detail" v-else>
    <!-- 从参数开始显示隐藏导航栏 -->
    <div class="nav" id="linbo">
      <div class="vanic">
        <van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
      </div>
      <div class="shangpinxiang" v-model="active">
        <van-tabs v-model="active">
          <van-tab>
            <div slot="title" id="tasi">
              <div @click="detaiil">
                <p>商品</p>
              </div>
            </div>
          </van-tab>
          <van-tab>
            <div slot="title">
              <div @click="pingjiatiao">
                <p>评价</p>
              </div>
            </div>
          </van-tab>
          <van-tab>
            <div slot="title">
              <div @click="dianjiping">
                <p>详情</p>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
      <div class="arrow-you">
        <van-goods-action-icon icon="shopping-cart-o" text="" to="/Carts"></van-goods-action-icon>
        <div class="foot" @click="shokaiww=true">
          <div class="dongside">
            <van-icon name="ellipsis" />
          </div>
        </div>
      </div>
    </div>
    <!-- 顶部轮播图 -->
    <div class="swiper">
      <van-swipe @change="onChange" :autoplay="2000">
        <van-swipe-item v-for="item in detaiList.slider_image">
          <img @click="getImg(detaiList.slider_image)" :src="item | handleUrl" alt="">
        </van-swipe-item>
        <div class="custom-indicator" slot="indicator">
          {{ current + 1 }}/{{detaiList.slider_image.length}}
        </div>
      </van-swipe>
    </div>
    <!-- 商品介绍 -->
    <div class="column" style="position: relative;">
      <div class="title">
        <div v-if="detaiList.category_id == 1" class="qinian">
          <span>租金</span>
          <span class="zujspecial">¥{{detaiList.select.Lease_algorithm_price}}</span>
          <span>/月</span>
          <span>
            <div class="qizi">起</div>
          </span>
        </div>
        <div v-else>
          <span>价格:</span>
          <span class="special">¥{{detaiList.price}}</span>
        </div>
        <div v-if="detaiList.category_id == 1">
          <span class="gongqi-yang">工期</span>
          <span class="special" v-if="detaiList.goods_work == 7">7-10天</span>
          <span class="special" v-if="detaiList.goods_work == 15">15-20天</span>
          <span class="special" v-if="detaiList.goods_work == 30">30-40天</span>
        </div>
      </div>
      <div class="main">
        <span>{{detaiList.title}}</span>
      </div>
      <!-- 			<div class="msg" v-if="detaiList.category_id == 1">
				<span>微信支付分或芝麻信用分达到600可申请减免部分押金，详情联系线下运营商400-8722-000</span>
			</div> -->
    </div>
    <!-- 规格选择 -->
    <div class="norms" id="pingjiatiao">
      <div class="list" v-if="detaiList.category_id == 1" @click="showw=true">
        <div style="padding: 0;">
          <span class="special-span">租赁</span>
          <span style="margin-left: 0.5rem;">月付租金，起租10个月租满24个月免费赠送...</span>
        </div>

        <van-icon name="ellipsis" />
      </div>
      <div class="list" @click="listSelect">
        <div style="padding: 0;">
          <span class="special-span">已选</span>
          <div style="width: 74%;;" v-if="detaiList.category_id == 1">
            <span>{{detaiList.goods_lease[leaseIndex].title}}</span>
            <span
              style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{detaiList.goods_spec_combination[sizeIndex].goods_spec_name}}</span>
          </div>
          <div style="width: 74%;" v-else>
            <span
              style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{detaiList.goods_spec_combination[sizeIndex].goods_spec_name}}</span>
          </div>
        </div>
        <van-icon name="ellipsis" />
      </div>
      <div class="list" @click="param=true">
        <span class="special-span">参数</span>
        <div>
          <span>品牌、工期、规格、材质</span>
          <span></span>
        </div>
        <van-icon name="ellipsis" />
      </div>
      <div v-if="defaultAddress === ''"></div>
      <div class="list" v-else>
        <span class="special-span">送至</span>
        <div>
          <van-icon size="14px" color="red" name="location-o" />
          <span
            class="special-site">{{defaultAddress.province}}{{defaultAddress.city}}{{defaultAddress.area}}{{defaultAddress.address}}</span>
        </div>
      </div>
      <div v-if="detaiList.category_id == 1" style="border: none;" class="list" @click="freight=true">
        <span class="special-span">运费</span>
        <div>
          <span>租金满5000元免运输安装费</span>
        </div>
        <van-icon name="ellipsis" />
      </div>
    </div>
    <!-- 评价 -->
    <div class="discuss">
      <div class="title">
        <div>
          <span class="special-span">评价</span>
          <span class="special-num" v-if="userList.length == 0">共0条评论</span>
          <span class="special-num" v-else>共{{userList.count.count}}+条评论</span>
        </div>
        <div>
          <span v-if="userList.length == 0">好评度100%</span>
          <span v-else>好评度100%</span>
          <van-icon name="arrow" color="#b6b6b6" />
        </div>
      </div>
      <div class="main_null" v-if="userList.length == 0">
        暂无评价
      </div>
      <div class="main" v-else>
        <div class="list" v-for="item in userList.data">
          <div class="user">
            <img src="../../assets/touxiang.png" alt="" v-if="item.anonymous == 0">
            <img src="../../assets/user.png" alt="" v-else-if="item.user.image == null">
            <img :src="item.user.image" alt="" v-else>
            <div class="user_name">
              <span class="user-span" v-if="item.anonymous == 0">神秘人</span>
              <span class="user-span" v-else>{{item.user.username}}</span>
              <van-rate :value="item.hot_num" readonly color="#ff4e35" size="0.5rem" gutter="0.2rem" />
            </div>
            <div class="time">{{item.create_time}}</div>
          </div>
          <div class="user-msg" v-if="item.content == ''">该用户暂无评论</div>
          <div class="user-msg" v-else>{{item.content}}</div>
          <div class="user_img">
            <img v-for="items in item.image" :src="items | handleUrl" alt="">
          </div>
        </div>
        <div class="see">
          <van-button round size="mini" type="default" @click="toComment">查看全部评价</van-button>
        </div>
      </div>
    </div>

    <!-- //进入品牌 -->
    <div class="jinruping—pai" v-if="detaiList.category_id == 1" @click="toBrand(detaiList.goods_brand.id)">
      <div class="pingpai-leftt">
        <div class="leftt-tu"><img :src="'https://backstage.jbj-china.com.cn/uploads'+tupian" alt=""> </div>
        <div class="saige">
          <p>{{detaiList.goods_brand.title}}</p>
          <van-rate size="0.7rem" color="#F1452F" gutter="1px" v-model="detaiList.goods_brand.hot_num" readonly
            v-if="detaiList.goods_brand.hot_num == 1" />
          <van-rate size="0.7rem" color="#F1452F" gutter="1px" v-model="detaiList.goods_brand.hot_num" readonly
            v-if="detaiList.goods_brand.hot_num == 2" />
          <van-rate size="0.7rem" color="#F1452F" gutter="1px" v-model="detaiList.goods_brand.hot_num" readonly
            v-if="detaiList.goods_brand.hot_num == 3" />
          <van-rate size="0.7rem" color="#F1452F" gutter="1px" v-model="detaiList.goods_brand.hot_num" readonly
            v-if="detaiList.goods_brand.hot_num == 4" />
          <van-rate size="0.7rem" color="#F1452F" gutter="1px" v-model="detaiList.goods_brand.hot_num" readonly
            v-if="detaiList.goods_brand.hot_num == 5" />
        </div>
      </div>


      <div class="pingpai-rightt">
        <div class="jintu-pai">
          <span> 查看全部</span> <img src="../../assets/tupian/箭头上 拷贝.png" alt="">
        </div>
        <div class="zaixian">
          <p>在线产品{{detaiList.goods_brand.count}}件</p>
        </div>
      </div>
    </div>

    <!-- 精品推荐 -->
    <div v-if="fineList.length > 0">
      <van-divider :style="{ color: '#000', borderColor: '#e0e0e0', padding: '0 16px' }">精品推荐</van-divider>
      <div class="lateral-sliding" id="div5">
        <div class="lateral-sliding-item" v-for="item in fineList">
          <div @click="goDetail(item.id)" class="dahejian">
            <img :src="item.image | handleUrl" alt="">
            <p>{{item.title}}</p>
            <p v-if="detaiList.category_id == 1">
              <span>租金</span>
              <span class="active" v-if="detaiList.category_id == 1">¥{{item.price}}</span><span
                class="yueqi">/月起</span>
            </p>
            <p v-else><span class="active">¥{{item.price}}</span></p>
          </div>
        </div>
      </div>
    </div>

    <!-- 商品详情 -->
    <van-divider :style="{ color: '#000', borderColor: '#e0e0e0', padding: '0 16px' }">商品详情</van-divider>
    <div class="detail-img" ref="richText" v-html='detaiList.content'>

    </div>
    <!-- 售后服务 -->
    <van-divider v-if="detaiList.category_id == 1"
      :style="{ color: '#000', borderColor: '#e0e0e0', padding: '0 16px' }">售后服务</van-divider>
    <van-divider v-else :style="{ color: '#000', borderColor: '#e0e0e0', padding: '0 16px' }">售后保障</van-divider>
    <div class="serve" v-if="detaiList.category_id == 1" v-html="detaiList.server_info"></div>
    <!-- 已选弹框 -->
    <div v-if="detaiList.select == undefined"></div>
    <van-popup v-else class="select" v-model="select" position="bottom" :style="{ 'max-height': '80%' }">
      <div class="title" v-if="detaiList.goods_lease.length != 0">
        <img @click="getImg(detaiList.select.goods_image)" :src="detaiList.select.goods_image | handleUrl" alt="">
        <div v-if="detaiList.category_id == 1 && detaiList.goods_lease[leaseIndex].lease_id != 4"
          style="margin-top: 10px;">
          <div>
            <span>首年租金:</span>
            <span class="select-span select-blod">¥{{detaiList.select.Lease_algorithm_price}}</span><span>/月</span>
            <span v-if="detaiList.select.Lease_month_price > 0" class="xuazuhs">
              <span class="xuzujian" style="color: #000000;">次年租金:</span>
              <span class="select-span select-blod">¥{{detaiList.select.Lease_month_price}}</span><span class="xuzujian"
                style="color: #000000;">/月</span>
            </span>
          </div>
          <div v-if="detaiList.select.total != 0">
            <span v-if="this.wan != 0"></span>
            <span v-else>买断金额:</span>
            <span class="select-span select-blod">¥{{detaiList.select.total}}</span>
          </div>
          <div
            style="color: #999; display: flex; justify-content: space-between; font-size: 12px; width: 15.125rem !important">
            <div v-if="detaiList.category_id == 1">市场购买参考含税价¥{{detaiList.select.market_price}}</div>
            <div>
              <span>剩余{{detaiList.select.goods_stuck}}件</span>
            </div>
          </div>
        </div>
        <!-- 押3付3 -->
        <div v-if="detaiList.category_id == 1 && detaiList.goods_lease[leaseIndex].lease_id == 4"
          style="margin-top: 10px;">
          <div>
            <span>月租金:</span>
            <span class="select-span select-blod">¥{{detaiList.select.Lease_algorithm_price}}</span>/月<span
              style="font-size: 0.6rem;">(24期)</span>
          </div>
          <!-- 					<div>
  						<span>次年租金:<span class="select-span select-blod">¥{{detaiList.select.Lease_month_price}}</span></span>/月
  						<span>&nbsp;&nbsp;</span>
  						<span>押金:<span class="select-span select-blod">¥{{detaiList.select.total}}</span></span>
  
  					</div> -->
          <div
            style="color: #999; display: flex; justify-content: space-between; font-size: 12px; width: 15.125rem !important">
            <div v-if="detaiList.category_id == 1">市场购买参考含税价¥{{detaiList.select.market_price}}</div>
            <div>
              <span>剩余{{detaiList.select.goods_stuck}}件</span>
            </div>
          </div>

        </div>
        <div v-if="detaiList.category_id != 1 && detaiList.goods_lease[leaseIndex].lease_id != 4">
          <div>
            <span class="select-span select-blod">价格:¥{{detaiList.select.total}}</span>
          </div>
          <div>
            <span>剩余:{{detaiList.select.goods_stuck}}</span>
          </div>
        </div>
        <van-icon name="cross" color="#fff" size="0.7rem" @click="select=false" />
      </div>
      <div class="title" v-else>
        <img @click="getImg(detaiList.select.goods_image)" :src="detaiList.select.goods_image | handleUrl" alt="">
        <div>
          <!-- 价格 -->
          <div>
            <span class="select-span select-blod">价格:¥{{detaiList.select.total}}</span>
          </div>
          <div>
            <span>剩余:{{detaiList.select.goods_stuck}}</span>
          </div>
        </div>
        <van-icon name="cross" color="#fff" size="0.7rem" @click="select=false" />
      </div>
      <div class="main">
        <div class="lable" v-if="detaiList.category_id == 1">
          <div v-if="this.wan == 0">租赁说明：<span class="yansezhi" style=" margin-left:0;">(支付36个月租金即可买断)</span></div>
          <div v-else-if="this.wan == 1">租赁说明:<span class=""
              style="font-size: 0.6rem; margin-left:0;">{{lease_id== 6?'' :('起租10个月租满三年免费赠送、支持提前退租')}}</span></div>
          <div v-else-if="this.wan == 2">租赁说明:<span class=""
              style=" margin-left:0;">{{lease_id== 6?'' :('起租10个月满24个月赠送、满18个月退租免违约金')}}</span></div>
        </div>
        <div v-if="detaiList.category_id == 1" class="main_lease">
          <div class="mianya_huan" style="margin-top: 0.5rem; display: block;">
            <button style="display: block;" @click="getPrice($event, index, item.lease_id)" data-type="0"
              :class="{active : index==leaseIndex}"
              v-for="(item, index) in detaiList.goods_lease">{{item.title}}</button>
          </div>

          <div class="mianya_huan" style="margin-top: 0.5rem; display: block; color: #2795EF;">
            * 月付租金需联系客服做资质审核400-8722-000
          </div>

        </div>

        <div class="lable">选择尺寸</div>
        <div class="main_size">
          <button @click="getPricee($event, index)" data-type="1"
            :class="{active : index==sizeIndex &&  item.goods_stuck>0,disabled: item.goods_stuck <= 0}"
            :disabled="item.goods_stuck <= 0"
            v-for="(item, index) in detaiList.goods_spec_combination">{{item.goods_spec_name}}</button>
        </div>
        <div class="number">
          <span>商品数量</span>
          <van-stepper v-model="value" button-size="1.1rem" />
        </div>
        <div style="color: red; text-align: right; margin-top: 0.9375rem; font-size: 12px;">>>加入产品方案</div>
      </div>
      <div class="btn">
        <button v-if="complete" class="btn-pay" @click="confirm">确定</button>
        <button v-else class="btn-pay" @click="confirm">完成</button>
      </div>
    </van-popup>
    <!-- 参数弹框 -->
    <van-popup class="param" v-model="param" position="bottom" :style="{ 'max-height': '70%' }">
      <div class="head">产品参数</div>
      <div class="list">
        <div class="list-title">品牌</div>
        <div class="list-value">{{detaiList.goods_brand.title}}</div>
      </div>
      <div class="list">
        <div class="list-title">货号</div>
        <div class="list-value">{{detaiList.goods_number}}</div>
      </div>
      <div class="list">
        <div class="list-title">工期</div>
        <div class="list-value" v-if="detaiList.goods_work == 7">7-10天</div>
        <div class="list-value" v-if="detaiList.goods_work == 15">15-20天</div>
        <div class="list-value" v-if="detaiList.goods_work == 30">30-40天</div>
      </div>
      <div class="list list_combination">
        <div class="list-title">规格</div>
        <div class="list-value">
          <div v-for="item in detaiList.goods_spec_combination">{{item.goods_spec_name}}</div>
        </div>
      </div>
      <div class="list" v-if="detaiList.place != ''">
        <div class="list-title">产地</div>
        <div class="list-value">{{detaiList.place}}</div>
      </div>
      <div class="list" v-if="detaiList.material != ''">
        <div class="list-title">材质</div>
        <div class="list-value">{{detaiList.material}}</div>
      </div>
      <div class="list" v-if="detaiList.dz != ''">
        <div class="list-title">定制</div>
        <div class="list-value" v-if="detaiList.dz === 0">定制</div>
        <div class="list-value" v-if="detaiList.dz === 1">非定制</div>
      </div>
      <div class="param_btn">
        <button @click="param=false">完成</button>
      </div>
    </van-popup>

    <van-action-sheet v-model="showw" position="bottom" :style="{ 'max-height': '70%' }" title="租赁方式">
      <div class="list-ti">
        <p>一次性买断（适用于长期使用）<a>无需续租，没有押金</a></p>
      </div>
      <div class="list-ti">
        <p>年付租金 <a>起租10个月租满三年免费赠送、支持提前退租</a></p>
      </div>
      <div class="list-ti">
        <p>月付租金 <a>起租10个月满24个月赠送、满18个月退租免违约金</a></p>
      </div>
      <div class="list-tast">
        <!-- 				<p>
					* 租金以实结算，用不完随时退
				</p> -->
        <p></p>
      </div>
      <div class="pabtton">
        <button @click="showw=false">完成</button>
      </div>
    </van-action-sheet>


    <van-popup class="param" v-model="freight" position="bottom" :style="{ 'max-height': '70%' }">
      <div class="head" style="margin: 0; padding-bottom: 0.8rem; border-bottom: 1px solid #eee;">运费说明</div>
      <div class="wenzism">
        1.品牌租赁商品订单租金金额满5000元免运输安装费，订单租金金额大于等于3000元且小于等于5000元收订单租金金额的15%运输安装费，订单租金金额小于3000元收300元的运输安装费。</div>
      <div class="wenzism">2.以上费用为市区区域且带货梯，若产生垂直运输费用及郊区县的运输费用（按照实际计算）由客户自己承担。</div>
      <div class="pabtton">
        <button @click="freight=false">确定</button>
      </div>
    </van-popup>

    <!-- //首页面板 -->
    <div class="overlay-ay">
      <van-action-sheet v-model="shokaiww" position="top"
        :style="{ 'max-height': '50%','width':'26%','left':'16rem','top':'5.5rem', 'height':'30.5%',}" class="dongzuo">
        <div class="pabttius">
          <van-icon name="wap-home-o" />
          <div class="hsouyetoto">
            <router-link to="/home" style="color:#000;position: relative;top:0.2rem;">首页</router-link>
          </div>
        </div>
        <div class="pabtton" position="top">
          <van-icon name="star-o" v-if="collection" />
          <van-icon name="star" v-else />
          <div @click="onClickIcon">收藏</div>
        </div>
        <div class="pabtton" position="top">
          <van-icon name="service-o" v-if="collection" />
          <van-icon name="service" v-else />
          <div @click="open53()">客服</div>
        </div>
        <div class="pabttius">
          <van-icon name="chat-o" />
          <div class="hsouyetoto">
            <div>消息</div>
          </div>
        </div>
        <div class="pabttiusfen">
          <van-icon name="wap-home-o" />
          <div class="hsouyetoto">
            <div>分享</div>
          </div>
        </div>
      </van-action-sheet>
    </div>

    <!-- 商品导航 -->
    <van-goods-action v-if="detaiList.category_id == 1">
      <div class="" style="display: flex;">
        <van-goods-action-icon icon="wap-home-o" text="首页" to="/home" />
        <van-goods-action-icon icon="cart-o" text="加入购物车" @click="onClickButton(1)" />
        <van-goods-action-icon icon="service-o" text="客服" @click="open53()" />
      </div>
      <div class="yuyeu" style="width: 56%;">
        <van-goods-action-button type="warning" text="预约上门" to="/yuyueshangmen" v-if="detaiList.category_id == 1" />
        <van-goods-action-button type="danger" @click="onClickButton(2)">
          <div v-if="detaiList.category_id == 1">
            <!-- 					<div  class="lijimai" v-if="detaiList.category_id == 1"> -->
            <!-- 						<p>提交订单</p>
						<p>选择租赁年限</p> -->
            <span style="font-weight: bold;">选择租赁时间</span>
          </div>
          <div class="lijimai" v-if="detaiList.category_id == 3" style="position:relative;top:0.7rem;">
            <p>立即支付</p>
          </div>
        </van-goods-action-button>
      </div>
    </van-goods-action>
    <van-goods-action v-else>
      <div class="" style="display: flex;">
        <van-goods-action-icon icon="wap-home-o" text="首页" to="/home" />
        <van-goods-action-icon icon="service-o" text="客服" @click="open53()" />
      </div>
      <div class="yuyeu" style="width: 70%;">
        <van-goods-action-button text="加入购物车"
          style="background: linear-gradient(to right,#faa307,#ff8917); color: #fff;" @click="onClickButton(1)" />
        <van-goods-action-button type="warning" text="预约上门" to="/yuyueshangmen" v-if="detaiList.category_id == 1" />
        <van-goods-action-button type="danger" @click="onClickButton(2)">
          <div class="lijimai" v-if="detaiList.category_id == 1">
            <p>提交订单</p>
            <p>选择租赁年限</p>
          </div>

          <div class="lijimai" v-if="detaiList.category_id == 3" style="position:relative;top:0.7rem;">
            <p>立即支付</p>
          </div>
        </van-goods-action-button>
      </div>
    </van-goods-action>
    <!-- 预览图 -->
    <van-image-preview v-model="show" :images="image"></van-image-preview>

  </div>
</template>
<script>
  import Login from '@/components/login/login'
  import Loding from '@/components/loding'
  import Customerservice from '@/components/customerservice'

  export default {
    name: 'detaill',
    data() {
      return {
        active: '',
        value1: 0,
        value2: 'a',
        option1: [{
            text: '全部商品',
            value: 0
          },
          {
            text: '新款商品',
            value: 1
          },
          {
            text: '活动商品',
            value: 2
          },
        ],
        option2: [{
            text: '默认排序',
            value: 'a'
          },
          {
            text: '好评排序',
            value: 'b'
          },
          {
            text: '销量排序',
            value: 'c'
          },
        ],

        nowIndex: 0,
        value: 1, //购买数量
        select: false, //已选弹框
        param: false,
        zupin: false,
        tasi: '',
        xinzenzu: false,
        showw: false,
        shokaiww: false,
        xianhsi: false,
        wancheng: true,
        //参数弹框
        freight: false,
        site: false, //地址弹框
        current: 0, //轮播图指示器
        tabList: false, //显示顶部导航栏
        leaseIndex: 0,
        shkaas: true,
        sizeIndex: 0,
        goods_lease_id: 0,
        chosenAddressId: '2', //默认选择地址
        isCards: -1, //是否是购物车,
        collection: true, //收藏
        //商品详情
        detaiList: [],
        //租赁方式
        listData: [{
            name: '商品',
            sex: '女',
            age: '24',
            score: 90
          },
          {
            name: '女',
            sex: '男',
            age: '23',
            score: 70
          },
          {
            name: '女',
            sex: '女',
            age: '29',
            score: 90
          },
        ],
        //用户评价

        userList: [],
        fineList: [],
        show: false,
        image: [],
        complete: false,
        url: '',
        defaultAddress: '',
        lease_id: '',
        wan: 0
      }
    },
    created() {
      //获取地址
      this.$axios.post(baseUrl + '/mobile/User/userAddressStatus', {
        token: localStorage.getItem('Authorization')
      }).then((res) => {
        if (res.data.code == 2) {
          this.defaultAddress = res.data.data
        }
      }).catch((err) => {
        console.log(err);
      });
      this.getData();
      this.goodsComment();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      window.pageYOffset = 0;
      // 上传浏览记录
      if (localStorage.getItem('Authorization') != "") {
        this.$axios.post(baseUrl + '/mobile/Base/browseAdd', {
          goods_id: this.$route.query.id,
          token: localStorage.getItem('Authorization')
        }).then((res) => {
          console.log(res)
        }).catch((err) => {
          console.log(err);
        });
      };
    },
    mounted() {
      window.addEventListener('scroll', this.hanldScroll);
    },
    methods: {
      detaiil(e) {
        this.tasi = e.screenY;
        document.getElementById("detail").scrollIntoView();
      },
      pingjiatiao() {
        document.getElementById("pingjiatiao").scrollIntoView();
      },
      dianjiping() {
        document.getElementById("div5").scrollIntoView();
      },
      changegoto(event) {
        console.log(event.target.innerHTML)
        // event.target.innerHTML = style:"'background'':'colorConfirm','padding':'7px'"
        // document.getElementById("div5").scrollIntoView();
        this.isActive = index;
      },
      toBrand(id) {
        this.$router.push({
          path: '/brandDetail',
          query: {
            id: id
          }
        })
      },
      //获取数据
      getData() {
        //页面跳转的时候那到当前id
        var id = this.$route.query.id;
        //给info传入id
        this.$axios.post(baseUrl + '/mobile/Goods/goodsInfo', {
          id: id
        }).then((res) => {
          if (res.data.code == 2) {
            this.tupian = res.data.data.goods_brand.brang_icon;
            this.detaiList = res.data.data;
            //默认选择
            if (this.detaiList.category_id == 1) {
              this.goods_lease_id = this.detaiList.goods_lease[0].lease_id;
            }
            this.$axios.post(baseUrl + '/mobile/Goods/goodsLeaseAlgorithm', {
              goods_spec_id: this.detaiList.goods_spec_combination[0].id,
              goods_lease_id: this.goods_lease_id,
              category_id: this.detaiList.category_id
            }).then((res) => {
              if (res.data.code == 2) {
                if (res.data.data.Lease_month_price == 0) {

                }
                this.$set(this.detaiList, 'select', res.data.data);
              }
            }).catch((err) => {
              console.log(err);
            })
            //精品推荐
            this.$axios.post(baseUrl + '/mobile/Base/goodsRecommend', {
              id: id,
              cat_id: this.detaiList.cat_id,
              limit: 10,
              category_id: this.detaiList.category_id,
            }).then((res) => {
              if (res.data.code == 2) {
                this.fineList = res.data.data;
              }
            }).catch((err) => {
              console.log(err);
            });
            for (var i = 0; i < res.data.data.goods_spec_combination.length; i++) {
              if (res.data.data.goods_spec_combination[i].goods_stuck > 0) {
                this.sizeIndex = i;
                break;
              }
            }
            if (this.detaiList.category_id == 1) {
              this.goods_lease_id = this.detaiList.goods_lease[0].lease_id
            }
          } else {
            this.$toast(res.data.msg);
            setTimeout(() => {
              this.back();
            }, 1000)
          }
        }).catch((err) => {
          console.log(err);
        })
      },
      goodsComment() {
        //获取评论
        this.$axios.post(baseUrl + '/mobile/Goods/goodsComment', {
          id: this.$route.query.id,
          page: 1,
          limit: 2
        }).then((res) => {
          if (res.data.code == 2) {
            this.userList = res.data;
          } else {
            this.userList = [];
          }
        }).catch((err) => {
          console.log(err);
        });
        //获取收藏信息
        this.$axios.post(baseUrl + '/mobile/Base/whatGoodsCollection', {
          id: this.$route.query.id,
          token: localStorage.getItem('Authorization')
        }).then((res) => {
          if (res.data.code == 13) {
            this.collection = false;
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      //监听页面滚动
      hanldScroll() {
        // var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        // if (scrollTop >= 1) {
        // 	this.tabList = true;
        // } else {
        // 	this.tabList = false;
        // }
      },
      //点击切换已选内容
      getPrice(event, idx, lease) {
        if (idx > 0) {
          this.shkaas = true;
          this.xinzenzu = false;
          this.xinzenzu = true;

        } else if (idx == 0) {
          this.shkaas = false
          this.xinzenzu = true;
          this.zupin = false;
        } else if (this.leaseIndex = 1) {

          this.xinzenzu = false;
          this.zupin = false;
        }
        var type = event.target.getAttribute('data-type');
        this.wan = idx
        if (type == 0) {
          this.leaseIndex = idx;
        } else {
          this.sizeIndex = idx;
          console.log(this.sizeIndex)
        }
      },
      getPricee(event, idx, lease) {
        //   console.log(idx)
        //    if(idx > 0){
        //     //  console.log(1)
        //  this.zupin = false;
        //  this.xinzenzu = true;
        //    }else if(idx <= 0){
        //     //  console.log(2)
        //     this.xinzenzu = true;
        //     this.zupin = false;
        //    }
        var type = event.target.getAttribute('data-type');
        if (type == 0) {
          this.leaseIndex = idx;
        } else if (this.leaseIndex == 0) {
          console.log("不限时")
          this.zupin = false;
          this.sizeIndex = idx;

        } else if (this.leaseIndex > 0) {
          console.log(this.leaseIndex)
          this.xinzenzu = false;
          // this.xinzenzu = true;
          this.zupin = true;
          this.sizeIndex = idx;
          console.log("显示")
        }
      },
      //轮播图指示器
      onChange(index) {
        this.current = index;
      },
      //判断是否跳转
      getClos(data) {
        this.isLogin = data;
      },
      //收藏信息
      onClickIcon() {
        this.whatLogin((bool) => {
          if (bool) {
            this.$axios.post(baseUrl + '/mobile/Base/goodsCollection', {
              id: this.$route.query.id,
              token: localStorage.getItem('Authorization')
            }).then((res) => {
              if (res.data.code == 15) {
                this.$toast(res.data.msg);
                this.collection = !this.collection;

              } else if (res.data.code == 17) {
                this.$toast(res.data.msg);
                this.collection = !this.collection;
              }
              this.shokaiww = false
            }).catch((err) => {
              console.log(err);
            })
          } else {
            this.$router.push({
              path: 'login',
              // query: {
              // 	id: this.$route.query.id
              // }
            });
          }
        })
      },
      onClickButton(type) {
        this.whatLogin((bool) => {
          if (bool) {
            if (type == 1) {
              this.complete = false;
            } else {
              this.complete = true;
            }
            this.select = true;
            this.isCards = type;
          } else {
            this.$router.push({
              path: 'login',
              // query: {
              // 	id: this.$route.query.id
              // }
            });
          }
        })
      },
      //tab切换视图区域
      toView() {
        document.getElementById("prefer").scrollIntoView();
      },
      //全部评论
      toComment() {
        this.$router.push({
          path: '/comment',
          query: {
            page: this.$route.query.id
          }
        })
      },
      //转确认订单
      confirm() {
        var sizeId = this.detaiList.goods_spec_combination[this.sizeIndex].id,
          category_id = this.detaiList.category_id,
          id = this.$route.query.id,
          value = this.value;
        if (value > this.detaiList.select.goods_stuck) {
          this.$toast('购买数量不能超过剩余库存!');
        } else {
          if (this.isCards == 1) {
            if (this.detaiList.goods_lease.length > 0) {
              var typeId = this.detaiList.goods_lease[this.leaseIndex].lease_id;
            } else {
              typeId = 0;
            }
            this.$axios.post(baseUrl + '/mobile/Cart/cartAdd', {
              goods_id: id,
              lease_id: typeId,
              combination_id: sizeId,
              cart_num: value,
              category_id: category_id,
              token: localStorage.getItem('Authorization')
            }).then((res) => {
              if (res.data.code == 5) {
                this.$toast(res.data.msg);
                this.select = false;
              } else {
                this.$toast("您选择的租赁方式与购物车中不一致，请重新选择租赁时间或清空购物车！");
              }
            }).catch((err) => {
              console.log(err);
            })
          } else {
            if (this.detaiList.goods_lease.length != 0) {
              var typeId = this.detaiList.goods_lease[this.leaseIndex].lease_id;
              this.$router.push({
                path: '/pays',
                query: {
                  id: id,
                  typeId: typeId,
                  sizeId: sizeId,
                  value: value,
                  type: 1,
                  category_id: this.detaiList.category_id
                }
              })
            } else {
              this.$router.push({
                path: '/pays',
                query: {
                  id: id,
                  sizeId: sizeId,
                  value: value,
                  type: 1,
                  category_id: this.detaiList.category_id
                }
              })
            }
          }
        }
      },
      //推荐详情
      goDetail(id) {

        this.$router.push({
          path: '/detail',
          query: {
            id: id
          }
        })

      },
      //已选弹框判断
      listSelect() {
        this.whatLogin((bool) => {
          if (bool) {
            this.select = true;
            this.complete = false;
          } else {
            this.select = false;
            this.isLogin = true;
          }
        })
      },
      //预览图
      getImg(img) {
        if (typeof(img) == 'string') {
          this.show = true;
          this.image = [];
          this.image.push(baseUrl + '/uploads/' + img);
        } else {
          this.show = true;
          this.image = [];
          for (var i = 0; i < img.length; i++) {
            this.image.push(baseUrl + '/uploads/' + img[i]);
          }
        }
      }
    },
    components: {
      Login,
      Loding,
      Customerservice,
    },
    watch: {
      'leaseIndex': function(newVal) {
        if (this.detaiList.category_id == 1) {
          this.goods_lease_id = this.detaiList.goods_lease[this.leaseIndex].lease_id
        }
        this.$axios.post(baseUrl + '/mobile/Goods/goodsLeaseAlgorithm', {
          goods_spec_id: this.detaiList.goods_spec_combination[this.sizeIndex].id,
          goods_lease_id: this.goods_lease_id,
          category_id: this.detaiList.category_id
        }).then((res) => {
          console.log(res.data.data)
          if (res.data.code == 2) {
            this.detaiList.select = res.data.data;
          }
        }).catch((err) => {
          console.log(err);
        })
      },
      'sizeIndex': function(newVal) {
        if (this.detaiList.category_id == 1) {
          this.goods_lease_id = this.detaiList.goods_lease[this.leaseIndex].lease_id
        }
        this.$axios.post(baseUrl + '/mobile/Goods/goodsLeaseAlgorithm', {
          goods_spec_id: this.detaiList.goods_spec_combination[this.sizeIndex].id,
          goods_lease_id: this.goods_lease_id,
          category_id: this.detaiList.category_id
        }).then((res) => {
          console.log(res)
          if (res.data.code == 2) {
            this.detaiList.select = res.data.data;

          }
        }).catch((err) => {
          console.log(err);
        })
      },
      //监听路由变化
      '$route'(to, from) {
        // 返回不刷新
        // this.$router.go(0);
        //把缓存存入
        if (to.name === 'detaill') {
          //跳转的的页面的名称是"NewRecruit",这里就相当于我们listview页面，或者原始页面
          this.$router.go(0);
          let screenYAll = this.$store.state.screenY

          //把在vuex里面的位置存入
          document.getElementsByClassName("vue-waterfall-easy-scroll")[0].scrollTop = screenYAll
        }




      },
      //离开清空路由
      // 存路由
      beforeRouteLeave(to, from, next) {
        //获取滚动条的高度
        let position = document.getElementsByClassName("vue-waterfall-easy-scroll")[0].scrollTop
        //离开路由存起来
        if (position == null) position = 0
        this.$store.commit('screenYAll', position) //离开路由时把位置存起来
        next()
      },
    },
    filters: {
      round(price) {
        return Math.round(price * 2.1 * 0.11);
      }
    },


  }
</script>
<style scoped>
  @import "detaill.css";

  .yansezhi {
    color: #f1452f;
  }

  .saige {
    text-align: left;
  }

  .nav {
    height: 3rem;
  }

  /* .arrow-you{
    position: relative;
    width: -30em;
    margin: 0 auto 5px;
    color: #323233;
    font-size: 18px;
  } */
  .arrow-you {
    display: flex;
    margin-top: -0.3rem;
  }

  .kefufuwu {
    position: absolute;
    top: 3.1rem;
    right: 0.1rem;
    margin-left: 0.4rem;
  }

  .checked {
    background: #eff4f7;
  }

  .list-tids p {
    color: #434343;
    font-size: 0.7rem;
    margin: 0 0.8rem;
    text-align: left;
    padding-top: 1rem;
  }

  .pabtton>>>.van-icon {
    position: relative;
    left: -1.2rem;
    color: #F1452F;
  }

  .pabttius>>>.van-icon {
    position: relative;
    top: 0.75rem;
    left: 0.1rem;
    padding-left: 0.5rem;
    color: #F1452F;
  }

  .pabttiusfen>>>.van-icon {
    position: relative;
    top: 0.75rem;
    left: 0.1rem;
    padding-left: 0.5rem;
    color: #F1452F;
  }

  .serve>>>p {
    margin: 0.8rem 0;
    color: #666 !important;
    font-size: 0.7rem !important;
    line-height: 1.5rem !important;
    margin-block-start: 0em;
    margin-block-end: 0em;
  }

  .serve>>>h4 {
    font-size: 0.8rem !important;
    color: #000 !important;
    font-weight: bold;
  }

  .serve>>>img {
    width: 95%;
    margin: auto;
    display: block;
  }

  .detail-img>>>img {
    display: block;
    width: 100%;
  }

  .detail-img>>>p {
    margin-block-start: 0em;
    margin-block-end: 0em;
    font-size: 0.875rem;
  }

  .detail-img>>>span {
    font-size: 0.7rem !important;
  }

  .pabttiusfen {

    height: 2.5rem;
    display: flex;
  }

  .pabttiusfen .van-icon {
    position: relative;
    top: 0.75rem;
  }

  .hsouyetoto {
    font-size: 0.8rem;
    position: relative;
    left: 0.8rem;
    top: 0.5rem;
  }

  .hsouyetoto div {
    position: relative;
    top: 0.2rem;
    color: #323233;
    font-size: 0.8rem;
  }

  .gongqi-yang {
    margin-right: -0.3rem;
  }

  .shangpinxiang>>>.van-tabs--line .van-tabs__wrap {
    height: 63px;
  }

  .list-xiand {
    width: 10%;
  }

  .zaixian {
    left: 2.1rem;
    position: absolute;
    top: 2.3rem;
    font-size: 0.75rem;
  }

  .detail-img p:nth-child(2) {
    color: aqua;
    font-size: 16rem !important;
  }

  .zujin_qu>div span:nth-child(2) {
    position: absolute;
    top: 1.3rem;
  }

  .list-kais {
    text-align: left;
    margin-top: 0.3rem;
  }

  .list-miadsn {

    color: #828282;
    position: absolute;
    left: 1.6rem;
    text-align: left;
    top: 10.1rem;
  }

  .list-ti p:nth-child(1) {
    width: 95%;
  }

  .list-ti p:nth-child(2) {
    width: 20%;
  }

  .lijimai {
    position: relative;
    top: 0.3rem;
  }

  .lijimai p:nth-child(2) {
    position: relative;
    top: -3.9rem;
    transform: scale(0.7);
  }

  .lijimai p:nth-child(1) {
    position: relative;
    top: -1.5rem;
    font-weight: bold;
  }

  .dahejian p:nth-child(3) {
    width: 85%;
  }

  .shangpinxiang>>>.van-hairline--top-bottom:after,
  .van-hairline-unset--top-bottom:after {
    border-width: 0px 0;
  }


  .qinian {
    display: flex;
  }

  .xuzushen {
    margin-left: 0.6rem;
  }

  .dongside>>>.van-icon {
    font-size: 1.8rem;

  }

  .dongzuo>>>.pabtton {
    border-bottom: 1px solid #f2f3f5;
    bottom: none;
    position: relative;
    /* left: 2rem; */
    height: 2.5rem;

  }

  .dongzuo>>>.van-popup {
    padding: 0rem !important;
    border-radius: 0.5rem 0.5rem 0.5rem 0.5rem !important;
  }

  .van-overlay {
    position: relative !important;
    background-color: rgba(0, 0, 0, 0) !important;


  }

  .dongzuo>>>.van-action-sheet__close {
    font-size: 0px;
  }

  .qinian span:nth-child(3) {
    color: red;
  }

  .qizi {

    color: red;

  }

  .list-ti>p>a {
    line-height: 1.6rem;
    color: #828282;
  }

  .changjia {
    color: #f1452f;
    display: flex;
    margin-top: 0.5rem;
  }

  .jinele {
    /* color: red; */
    font-size: 0.7rem !important;

  }

  .pabttius {
    border-bottom: 1px solid #f2f3f5;
    height: 2.5rem;
    display: flex;
  }


  .yueqi {
    color: red;
  }

  /* .kefuzixun{
    width: 50%;
  } */
  .shangpinxiang a {
    color: #ffffff;
    font-size: 1rem;
  }

  .nav>>>.van-goods-action-icon__icon {
    font-size: 20px;
  }

  .shangpinxiang a:before {
    -webkit-transition: width .2s ease-in-out;
    transition: width .2s ease-in-out;
    left: 0;
    content: "";
    position: absolute;
    bottom: 0;
    width: 0;
    border-bottom: solid 3px #ff3a3a;
  }

  .shangpinxiang>>>.van-tabs__line {
    background-color: #f7f8fa;
  }

  .shangpinxiang>>>.van-tab__text {
    font-size: 0.9rem;
    position: relative;
    top: 1rem;
    color: #f7f8fa;
  }

  .shangpinxiang>>>.van-tabs__line {
    position: absolute;
    bottom: 15px;
  }

  .vanic>>>.van-icon {
    position: relative;
    top: 0.3rem;
  }

  .shangpinxiang>>>.van-tabs--line .van-tabs__wrap {
    position: relative;
    top: -1rem;

  }

  .nav .van-icon {
    position: relative;

  }

  /* .shangpinxiang >>> .van-tab--active{
  margin:0rem 1rem;
} */
  .shangpinxiang>>>.van-tab {
    margin: -0.4rem 1rem;
  }

  /* .shangpinxiang >>> .van-tab:nth-child(3){
  margin: 0.4rem 0 0 0;
} */

  .shangpinxiang>>>.van-tabs__line {
    width: 2rem !important;
  }

  .changjia div:nth-child(1) {
    height: 1.2rem;
    margin: 0 1rem;
    border-radius: 0.2rem;
    text-align: center;
    width: 6rem;
    margin: 0 0 0 0rem;
    line-height: 1rem;
    border-radius: 0.2rem;
    background: #FF3300;
  }

  .changjia div:nth-child(2) {
    height: 1.2rem;
    text-align: center;
    width: 4rem;
    line-height: 1rem;
    margin: 0 0.5rem;
    border-radius: 0.2rem;
    background: #FF3300;
    /* background:#FF3300; */
  }

  .hanyajin_tui {
    margin-left: 0.6rem;
  }

  .qinian span {
    line-height: 1.5rem;
  }

  .nav .van-goods-action-icon__icon:nth-child(1) {
    position: relative;
    left: 0.3rem;
  }

  .changjia div:nth-child(3) {
    border-radius: 0.2rem;

    background: #FF3300;
    /* margin: 0 1rem; */

    /* border-radius:1rem ; */
    /* margin: 0 0.3rem; */
    line-height: 1rem;
    border: 1px solid red;
    /* background: #FF3300; */

    text-align: center;
    width: 6rem;
  }

  .hsouyetoto {}

  .overlay-ay>>>.van-overlay {
    background-color: rgba(0, 0, 0, 0);
  }

  .overlay-ay>>>.van-popup {
    padding: 0rem;
    border-radius: 0.5rem;
    box-shadow: 0px 1px 5px 0px #c8c9cc;
  }

  .changjia span {
    font-size: .1rem;
    /* font-size: 0.2rem; */
    color: #ffffff;
    white-space: nowrap;
    -webkit-transform-origin-x: 0;

    -webkit-transform: scale(0.80);
    /* -webkit-transform: scale(0.80);
    -webkit-transform-origin-x: 0;  */
  }

  .kefufuwu {
    margin-left: 0.4rem;
  }

  .xuzujian {
    font-size: 0.7rem;
    color: #b1b1b1;


  }

  .pabtton div {
    font-size: 0.8rem;
    position: relative;
    left: -0.4rem;
  }


  .keyuiya {
    margin-left: 0.6rem;
  }

  .shangpinxiang>>>.van-tabs__nav--line {
    background: #F1452F;
  }

  .xuazuhs {
    margin-left: 0.6rem;
  }

  .dahejian {
    /* position: relative; */
  }

  .jinruping—pai {
    height: 5.5rem;
    background: #ffffff;
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
  }

  .pingpai-leftt {

    display: flex;
  }

  .yuyeu>>>.van-goods-action-button:nth-child(1) {
    font-weight: bold;
  }

  .pingpai-rightt {
    position: relative;
    width: 40%;

  }


  .arrow-you>>>.van-goods-action-icon:nth-child(1) {
    display: -webkit-box;
    top: 0.4rem;
    position: relative;
    left: 0.4rem;

    background: #f1452f;

  }

  .dongside>>>.van-icon {
    top: 0.3rem;
  }

  .arrow-you>>>.van-goods-action-icon:nth-child(2) {
    top: 0.2rem;
    position: relative;
    height: 0rem;
    display: -webkit-box;


  }

  /* .arrow-you >>> .van-goods-action-icon:nth-child(1){
    left: 0.8rem;
    position: relative;


  } */
  /* .arrow-you >>> .van-goods-action-icon__icon{
    color: #ffffff;

  } */
  .arrow-you>>>.van-goods-action-icon__icon {
    color: #eff4f7 !important;
  }

  .arrow-you .van-goods-action-icon__icon:nth-child(1) {
    position: relative;
    top: 0.2rem;
  }

  .leftt-tu {
    background: #f7f8fa;
    border-radius: 53rem;
    height: 4rem;
    width: 4rem;
    margin: 0.8rem 1rem;
    /* width: 3rem;
    height: 3rem;
    background-size:100% 100%; */
    /* box-sizing: 100% 100%; */
    /* background:url(../../assets/tupian/suiyuan.png) no-repeat; */

    /* background-image:url("../../assets/tupian/椭圆\ 5.png"); */
  }

  .yuyeu {
    width: 93%;
    display: flex;
  }

  .wenzi-zi {
    width: 4rem;
    height: 6rem;
  }

  .pingpai-leftt {}

  .leftt-tu img {
    width: 3.2rem;
    height: 1.7rem;
    margin-top: 1rem;
    object-fit: cover;


  }

  .saige p:nth-child(2) {
    margin-top: 0.8rem;
    margin-left: -0.4rem;
    color: #666666;
    font-size: 0.8rem;
  }

  .saige p:nth-child(3) {
    margin-top: 0rem;
    margin-left: -0.4rem;
    color: #666666;
    font-size: 0.8rem;
  }

  .saige p:nth-child(1) {
    color: #000000;
    font-size: 1rem;
    margin: 0rem 0rem 0rem 0rem;
    margin-top: 1.5rem;
  }

  .jintu-pai span {
    font-size: 0.9rem;
    left: 2.1rem;
    color: red;
    position: absolute;
    top: 1.5rem;
  }

  .jintu-pai img {
    position: absolute;
    top: 1.7rem;
    left: 6.4rem;
    width: 0.6rem;
    height: 0.7rem;
  }

  .min .top>img[data-v-5dc7ae96] {
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 50%;
    margin-right: 0.7rem;

    object-fit: cover;
  }

  .jinelee {
    font-weight: bold;
    font-size: 0.7rem !important;
  }

  #detail>>>.van-goods-action {
    justify-content: space-around;
    margin-right: 0.2rem;
  }

  .zujspecial {
    color: red;
    font-size: 1.3rem;
    margin: 0 0.3rem;
    margin-top: -1px;
  }

  .wenzism {
    font-size: 0.8rem;
    color: #828282;
    line-height: 1.625rem;
    margin-top: 0.625rem;
  }

  .norms :last-child {
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/detaill/detaill.vue